import "core-js/modules/es.array.join";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { configGradeList, sendCmd } from '@/api/apis';
export default {
  data: function data() {
    return {
      dialogVisible: false,
      tag: '',
      gradeList: [],
      groupList: [{
        key: 'B49981660',
        value: '义系-贾红英'
      }, {
        key: 'B78869475',
        value: '义系-刘春梅'
      }, {
        key: 'B57674849',
        value: '智系-孙肖'
      }, {
        key: 'B27917835',
        value: '信系-王树颖'
      }, {
        key: 'B24586540',
        value: '礼系-徐敏'
      }, {
        key: 'B72260199',
        value: '仁系-黄金库'
      }, {
        key: 'B84167861',
        value: '礼系-周建申'
      }],
      form: {
        numbers: '',
        groups: [],
        grade: 0,
        filters: ''
      },
      rules: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    for (var i in this.groupList) {
      this.form.groups.push(this.groupList[i].key);
    }

    configGradeList({}).then(function _callee(res) {
      return regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.gradeList = res;

            case 1:
            case "end":
              return _context.stop();
          }
        }
      });
    });
  },
  methods: {
    show: function show(tag, finish) {
      this.dialogVisible = true;
      this.tag = tag;
      this.finish = finish;
    },
    clickImport: function clickImport() {
      this.$refs.import.value = null; //解决change事件在同一个文件下不触发的问题

      this.$refs.import.click();
    },
    onExcelImport: function onExcelImport(event) {
      var _this2 = this;

      var file = event.target.files[0];
      this.$import.xlsx(file).then(function (_ref) {
        var header = _ref.header,
            results = _ref.results;

        if (results.length === 0) {
          return;
        }

        if (!results[0].hasOwnProperty('会员编号')) {
          _this2.$alert('请添加"会员编号"列', '提示', {
            confirmButtonText: '确定',
            callback: function callback(action) {}
          });

          return;
        }

        var tmp = [];

        for (var i in results) {
          tmp.push(results[i]['会员编号']);
        }

        _this2.form.numbers = tmp.join(',');
      }); // 阻止默认的上传

      return false;
    },
    clickSubmit: function clickSubmit() {
      var _this3 = this;

      this.$refs['form'].validate(function (valid) {
        console.log('this,firn', _this3.form);

        if (valid) {
          var params = [];
          var tag = _this3.tag;

          if (tag === 'sta2') {
            params = [tag, '-numbers', _this3.form.numbers, '-groups', _this3.form.groups.join(',')];
          } else if (tag === 'sta3') {
            params = [tag, '-numbers', _this3.form.numbers, '-grade', _this3.form.grade];
          } else if (tag === 'sta4') {
            params = [tag, '-numbers', _this3.form.numbers, '-filters', _this3.form.filters];
          }

          sendCmd(params).then(function _callee2(res) {
            return regeneratorRuntime.async(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _this3.$alert('命令执行成功，请稍后再次刷新列表', '提示', {
                      confirmButtonText: '确定',
                      callback: function callback(action) {
                        _this3.dialogVisible = false;

                        _this3.finish();
                      }
                    });

                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }
            });
          });
        }
      });
    }
  }
};